// =====================================================================
//  Copie dans le presse-papiers, robuste
//  ---------------------------------------------------------------------
//  navigator.clipboard peut être refusé (contexte non sécurisé, permission,
//  navigateur embarqué, document sans focus pendant une fenêtre modale).
//  Repli sur execCommand("copy") via un textarea temporaire, puis, en
//  dernier recours, l'appelant est prévenu (false) pour proposer la copie
//  manuelle.
// =====================================================================

export class Clipboard {
    public static Copy = async (text: string): Promise<boolean> => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return true;
            }
        } catch {
            // repli ci-dessous
        }
        return Clipboard.#legacyCopy(text);
    };

    static #legacyCopy = (text: string): boolean => {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.top = "-1000px";
        ta.style.opacity = "0";
        // Ajouté dans l'élément actif (ex. fenêtre Kendo modale) pour que la
        // sélection ne soit pas bloquée par le piège de focus de la modale.
        (document.activeElement?.closest(".k-window") ?? document.body).appendChild(ta);
        ta.select();
        let ok = false;
        try {
            ok = document.execCommand("copy");
        } catch {
            ok = false;
        }
        ta.remove();
        return ok;
    };
}
